export const WG_REPO = 'WG_REPO';
export const WG_SERVICE = 'WG_SERVICE';
